export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/item_length_worker.42e69ed8.worker.js");
}
